import { utilsQuery } from "@app/common";

const define = utilsQuery.defineQueryKeyCreator("navigation");

export const QueryKeys = {
    MainNavigationItems: define("main-navigation-items"),
} as const;
